import { Card, Typography, Stack, Divider, IconButton } from "@mui/material";
import { Box } from "@mui/system";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../../assets/styles/tokens";
import { useState } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
// ─────────────────────────────────────────────────────────────────────────────

interface ClicksWithFtdProps {
  brand_name: string;
  brand_id: string;
  click_out: number | string;
  table: string;
  link_name: string;
}

export function ClicksWithFtdCard({
  brand_name,
  brand_id,
  click_out,
  table,
  link_name,
}: ClicksWithFtdProps) {
  const [copiedLink, setCopiedLink] = useState<string | null>(null);

  const handleCopyLink = async (link: string) => {
    await navigator.clipboard.writeText(link);
    setCopiedLink(link);

    setTimeout(() => {
      setCopiedLink(null);
    }, 2000);
  };

  return (
    <>
      <Card
        sx={{
          p: 1,
          borderRadius: spacing.Radius.lg.$value,
          boxShadow: "0px 1px 2px #0A0D120F , 0px 1px 3px #0A0D121A",
          border: "1px solid" + colors.GrayLightMode[200].$value,
          mb: spacing.Spacing.none.$value,
          mt: spacing.Spacing.xl.$value + "!important",
        }}
      >
        {/* Top Row */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            variant="body1"
            sx={{
              color: colors.GrayLightMode[700].$value,
              fontSize: typography.Size.Text.xs.$value,
              fontWeight: typography.Font_weight.Medium.$value,
            }}
          >
            {brand_name} ({brand_id})
          </Typography>
          <Box
            display={"flex"}
            alignItems={"center"}
            onClick={() => handleCopyLink(link_name)}
            data-tracker="903"
          >
            <IconButton
              size="small"
              sx={{ mr: 0.5, p: 0, color: colors.Brand[700].$value }}
            >
              {copiedLink === link_name ? (
                <CheckIcon
                  sx={{ color: colors.Brand[700].$value }}
                  fontSize="small"
                />
              ) : (
                <ContentCopyIcon fontSize="small" />
              )}
            </IconButton>
            <Typography
              color="secondary"
              variant="subtitle1"
              sx={{
                fontSize: typography.Size.Text.sm.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                color: colors.Brand[700].$value,
              }}
            >
              {" "}
              {copiedLink === link_name ? "Copied!" : "Copy link"}
            </Typography>
          </Box>
        </Stack>

        <Stack sx={{ mb: spacing.Spacing.xs.$value }}>
          <Typography
            variant="body1"
            sx={{
              fontSize: typography.Size.Text.sm.$value,
              color: colors.GrayLightMode[900].$value,
            }}
          >
            <Box
              component="span"
              sx={{
                fontSize: typography.Size.Text.xl.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                mr: spacing.Spacing.xs.$value,
              }}
            >
              {click_out}
            </Box>
            Click outs, Table:
            <Box
              component="span"
              sx={{
                fontSize: typography.Size.Text.sm.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                ml: spacing.Spacing.xs.$value,
              }}
            >
              {table}
            </Box>
          </Typography>
        </Stack>

        <Divider />
        <Typography
          variant="body1"
          sx={{
            color: colors.GrayLightMode[900].$value,
            fontSize: typography.Size.Text.xxs.$value,
            fontWeight: typography.Font_weight.Medium.$value,
            mt: spacing.Spacing.md.$value,
            wordBreak: "break-all",
          }}
        >
          {link_name}
        </Typography>
      </Card>
    </>
  );
}
export default ClicksWithFtdCard;
